import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { 
  getFirestore, 
  collection, 
  addDoc, 
  query, 
  orderBy, 
  onSnapshot, 
  serverTimestamp, 
  where,
  doc,
  getDocs,
  updateDoc,
  increment,
  deleteDoc,
  setDoc
} from "firebase/firestore";
import { getMessaging, onMessage, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyB1dPEyvN6cyIrpISAdZfYnCc74Wvopz5E",
  authDomain: "lisachar-656fd.firebaseapp.com",
  projectId: "lisachar-656fd",
  storageBucket: "lisachar-656fd.appspot.com",
  messagingSenderId: "431682139114",
  appId: "1:431682139114:web:82c75e15f4f03ba021f893",
  measurementId: "G-DHL2XKMB7Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const db = getFirestore(app);
const auth = getAuth(app);
const messaging = getMessaging(app);

// Request permission and get FCM token (web push)
export async function getFcmToken() {
  try {
    // const messaging = getMessaging();

    const permission = Notification.permission;
    if (permission === 'denied') {
      console.warn("Notifications are blocked by the user.");
      return null;
    } else if (permission === 'default') {
      // Ask permission with timeout
      const permissionPromise = Notification.requestPermission();
      const timeoutPromise = new Promise((_, reject) => 
        setTimeout(() => reject(new Error('Permission request timeout')), 5000)
      );
      
      const result = await Promise.race([permissionPromise, timeoutPromise])
        .catch(err => {
          console.warn('Permission request timed out');
          return null;
        });
      
      if (result !== 'granted') {
        console.warn("User did not grant notification permission.");
        return null;
      }
    }

    // Add timeout to service worker ready
    const swPromise = navigator.serviceWorker.ready;
    const swTimeoutPromise = new Promise((_, reject) => 
      setTimeout(() => reject(new Error('Service worker ready timeout')), 3000)
    );
    
    let registration;
    try {
      registration = await Promise.race([swPromise, swTimeoutPromise]);
    } catch (err) {
      console.warn('Service worker not ready, continuing without it');
      registration = null;
    }

    const token = await getToken(messaging, {
      vapidKey: "BCuFDqsvDAXHX4KhojSuZza3VNA0qF4s3i4FwvM2oN9Whqu0LJeylqz-_3IXVhtqEQLQFlRnOuy6cYzPuaRPfaA",
      serviceWorkerRegistration: registration // Only pass if we have it
    });

    return token;
  } catch (err) {
    console.error("Error while retrieving token:", err);
    return null;
  }
}
// ✅ MOVED OUTSIDE - THIS IS CORRECT NOW
// THIS IS FOR TESTING ONLY - In production, this should be on your backend
export const sendTestFCMMessage = async (fcmToken) => {
  try {
    // This is the correct format for FCM HTTP v1 API
    const message = {
      message: {
        token: fcmToken,
        notification: {
          title: '💊 Medication Reminder',
          body: 'Time to take your medication'
        },
        data: {
          medicationId: 'test-123',
          click_action: 'OPEN_MEDICATION_PAGE',
          channelId: 'medication_reminders'
        },
        android: {
          priority: 'high',
          notification: {
            title: '💊 Medication Reminder',
            body: 'Time to take your medication',
            icon: 'pill192',
            color: '#4CAF50',
            sound: 'default',
            channelId: 'medication_reminders',
            priority: 'high',
            visibility: 'public',
            notificationCount: 1,
            ticker: 'Medication due!',
            sticky: false,
            vibrateTimings: ['0s', '0.2s', '0.1s', '0.2s'],
            clickAction: 'OPEN_ACTIVITY',
            tag: 'medication-reminder'
          }
        },
        webpush: {
          notification: {
            title: '💊 Medication Reminder',
            body: 'Time to take your medication',
            icon: '/pill192.png',
            badge: '/pillbadge.png',
            vibrate: [200, 100, 200],
            requireInteraction: true,
            actions: [
              {
                action: 'take',
                title: 'Take Now'
              }
            ]
          }
        }
      }
    };

    // You need to get an OAuth2 token for FCM v1
    // This is a simplified version - you'll need proper authentication
    const response = await fetch(`https://fcm.googleapis.com/v1/projects/lisachar-656fd/messages:send`, {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer YOUR_ACCESS_TOKEN', // You need to generate this
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(message)
    });

    return await response.json();
  } catch (error) {
    console.error('Error sending FCM message:', error);
  }
};


// Export everything needed
export { 
  db,
  auth,
  collection, 
  addDoc, 
  setDoc,
  doc,
  query, 
  orderBy, 
  onSnapshot, 
  serverTimestamp, 
  where,
  getDocs,
  updateDoc,
  increment,
  deleteDoc
};

export default app;